import { useModalContext } from '#pplx/frontend/aether/modals/context/useModalContext.js';
import { memo, useEffect, useRef } from 'react';
function DeclarativeModalImpl({ modal, props, }) {
    const { openModal } = useModalContext();
    const handlers = useRef(null);
    const latestProps = useRef(props);
    latestProps.current = props;
    useEffect(() => {
        if (modal) {
            handlers.current = openModal(modal, latestProps.current, { replace: false });
            return () => {
                if (handlers.current) {
                    handlers.current.closeModal();
                    handlers.current = null;
                }
            };
        }
        return undefined;
    }, [modal, openModal]);
    useEffect(() => {
        handlers.current?.updateModal(props);
    }, [props]);
    return null;
}
export const DeclarativeModal = memo(DeclarativeModalImpl);
//# sourceMappingURL=DeclarativeModal.js.map